import { IconSvg, IconSvgProps } from "./icon"

export default function SkipForward(props: IconSvgProps) {
  return (
    <IconSvg {...props} fill="currentColor">
      <path d="M21 4V20" />
      <path
        d="M6.029 4.28502C5.72551 4.10292 5.37913 4.00462 5.02523 4.00016C4.67133 3.99569 4.32259 4.08522 4.0146 4.2596C3.70661 4.43398 3.45041 4.68697 3.27216 4.99274C3.09391 5.2985 3 5.64609 3 6.00002V18C3 18.3539 3.09391 18.7015 3.27216 19.0073C3.45041 19.3131 3.70661 19.5661 4.0146 19.7404C4.32259 19.9148 4.67133 20.0043 5.02523 19.9999C5.37913 19.9954 5.72551 19.8971 6.029 19.715L16.026 13.717C16.3228 13.5397 16.5685 13.2885 16.7393 12.9879C16.91 12.6873 16.9999 12.3476 17.0002 12.0019C17.0005 11.6562 16.9112 11.3163 16.741 11.0154C16.5708 10.7145 16.3255 10.4628 16.029 10.285L6.029 4.28502Z"
        strokeWidth={0}
      />
    </IconSvg>
  )
}
